// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__3QC3Z","item":"styles_item__3Na8W"};